
<template>
  <div>
    <!-- <mheader></mheader> -->
    <div
      v-show="tableData.length > 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            调价管理
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
          </span>
          <span class="ml-5" style="color: red">
            每天晚上8点以后,早晨6点前不能进行调价操作
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600"
            >调价详细(凡是没有上传图片的药品，均不显示！双击生产厂家可以快速检索！双击药品名称可以查询同类产品！)</span
          >
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font heit"
                          v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>
              <button
                class="bg-primary button_zi heit ml-5"
                @click="changePage()"
              >
                调价记录
              </button>
            </div>
          </div>
        </div>

        <table
          v-if="searchData.length > 0"
          class="table table-striped table-hover"
          ref="print"
        >
          <thead>
            <tr style="white-space: nowrap" class="text-center">
              <th>药品名称</th>
              <th>产地名称</th>
              <th>库区</th>
              <th>规格</th>
              <th>批号</th>
              <th>单位</th>
              <!-- <th>单价</th> -->
              <th>零/整</th>
              <th>包装</th>
              <th>库存</th>
              <th>可销售数量</th>
              <th>有效期至</th>
              <th>入账日期</th>
              <!-- <th>打折情况</th>
                        <th>返利情况</th> -->
              <th style="color: green">批量价</th>
              <!-- <th>批量价2</th> -->
              <th>进价</th>
              <th>零批价</th>
              <th>零售价</th>
              <th style="color: red">折后价</th>
              <th>修改价格</th>
              <th>确认修改</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in searchData"
              :key="index"
              class="text-center"
            >
              <td class="jz_middle" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td class="jz_middle" @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td class="jz_middle">{{ item.storeNo }}</td>
              <td class="jz_middle">{{ item.spec }}</td>
              <td class="jz_middle">{{ item.batchNum }}</td>
              <td class="jz_middle">{{ item.unit }}</td>
              <!-- <td class="jz_middle">{{item.price}}</td> -->
              <td class="jz_middle">{{ item.isRetail | lin }}</td>
              <td class="jz_middle">{{ item.pack }}</td>
              <td class="jz_middle">{{ item.storeNum }}</td>
              <td class="jz_middle">{{ item.canSaleNum }}</td>
              <td class="jz_middle">{{ item.dueDate }}</td>
              <td class="jz_middle">{{ item.inAccountDate | formatUTC }}</td>
              <td class="jz_middle" style="color: green">{{ item.price }}</td>
              <!-- <td class="jz_middle">{{item.tradePrice}}</td> -->
              <td class="jz_middle">{{ item.purchPrice }}</td>
              <td class="jz_middle">{{ item.retailPrice }}</td>
              <td class="jz_middle">{{ item.highestPrice }}</td>
              <!-- <td class="jz_middle">{{item.disCountRate | rate}}</td>
                              <td class="jz_middle">{{item.isPromotion}}</td> -->
              <td class="jz_middle" style="color: red">{{ item.zhj }}</td>
              <td class="jz_middle">
                <input
                  type="text"
                  class="text-center"
                  style="width: 60px"
                  v-model="item.value"
                />
              </td>
              <td class="jz_middle">
                <button
                  class="bg-primary button_zi heit"
                  @click="GetTiaoJia(index)"
                >
                  确定
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-striped table-hover" ref="print" v-else>
          <thead>
            <tr style="white-space: nowrap" class="text-center">
              <th>药品名称</th>
              <th>产地名称</th>
              <th>库区</th>
              <th>规格</th>
              <th>批号</th>
              <th>单位</th>
              <!-- <th>单价</th> -->
              <th>零/整</th>
              <th>包装</th>
              <th>库存</th>
              <th>可销售数量</th>
              <th>有效期至</th>
              <th>入账日期</th>
              <!-- <th>打折情况</th>
                        <th>返利情况</th> -->
              <th style="color: green">批量价</th>
              <!-- <th>批量价2</th> -->
              <th>进价</th>
              <th>零批价</th>
              <th>零售价</th>
              <th style="color: red">折后价</th>
              <th>修改价格</th>
              <th>确认修改</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in tableData"
              :key="index"
              class="text-center"
            >
              <td class="jz_middle" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td class="jz_middle" @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td class="jz_middle">{{ item.storeNo }}</td>
              <td class="jz_middle">{{ item.spec }}</td>
              <td class="jz_middle">{{ item.batchNum }}</td>
              <td class="jz_middle">{{ item.unit }}</td>
              <!-- <td class="jz_middle">{{item.price}}</td> -->
              <td class="jz_middle">{{ item.isRetail | lin }}</td>
              <td class="jz_middle">{{ item.pack }}</td>
              <td class="jz_middle">{{ item.storeNum }}</td>
              <td class="jz_middle">{{ item.canSaleNum }}</td>
              <td class="jz_middle">{{ item.dueDate }}</td>
              <td class="jz_middle">{{ item.inAccountDate | formatUTC }}</td>
              <td class="jz_middle" style="color: green">{{ item.price }}</td>
              <!-- <td class="jz_middle">{{item.tradePrice}}</td> -->
              <td class="jz_middle">{{ item.purchPrice }}</td>
              <td class="jz_middle">{{ item.retailPrice }}</td>
              <td class="jz_middle">{{ item.highestPrice }}</td>
              <!-- <td class="jz_middle">{{item.disCountRate | rate}}</td>
                              <td class="jz_middle">{{item.isPromotion}}</td> -->
              <td class="jz_middle" style="color: red">{{ item.zhj }}</td>
              <td class="jz_middle">
                <input
                  type="text"
                  class="text-center"
                  style="width: 60px"
                  v-model="item.value"
                />
              </td>
              <td class="jz_middle">
                <button
                  class="bg-primary button_zi heit"
                  @click="GetTiaoJia(index)"
                >
                  确定
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 分页 -->
        <div>
          <v-pagination
            :total="total"
            :current-page="current"
            @pagechange="pagechange"
          ></v-pagination>
        </div>

        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
      <!-- container -->
    </div>

    <div
      v-show="Pcount === 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            库存查询
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
            <!-- <span>
                         <span class="ml-3">
                              总金额:
                         </span>
                          <span style="color:red;font-size:15px;">
                            ¥{{totalPurchMoney}}
                          </span>
                      </span> -->
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600"
            >调价详细(凡是没有上传图片的药品，均不显示！双击生产厂家可以快速检索！双击药品名称可以查询同类产品！)</span
          >
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font heit"
                          v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>
              <button
                class="bg-primary button_zi heit ml-5"
                @click="changePage()"
              >
                调价记录
              </button>
              <!-- <button class="bg-success button_zi ml-lg-2" @click="start_print()">打印页面</button>
                                 <button class="bg-success button_zi ml-lg-2" @click="exportExcel1()">导出本页</button>
                                 <button class="bg-success button_zi ml-lg-2" @click="exportExcel()">导出查询EXCEL</button> -->
            </div>
          </div>
        </div>
        <img
          src="../../static/images/wushuju.jpg"
          style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt=""
        />
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
    </div>

    <div>
      <transition name="fade">
        <loading v-show="isLoading"> </loading>
      </transition>
    </div>

    <!-- 这里是弹出框的内容 -->
    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="
            width: 1200px;
            position: relative;
            top: 50px;
            left: -150px;
            margin-bottom: 50px;
          "
        >
          <div class="modal-header">
            <button
              type="button"
              class="close m-0 p-1"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-header">
                <div class="font">查询同类产品</div>
              </div>
              <div class="card-body">
                <!-- <div class="form-group d-flex">
                                                    <input type="text" class="form-control w-25" placeholder="药品名称" v-model="searchForm.searchKey" @keydown.enter="searchEnterFun1">
                                                    <button class="ml-lg-2 btn btn-primary" @click="getSupplierQuery()">
                                                        查询
                                                    </button>
                                               </div> -->

                <div class="row ml-2 mb-2">
                  <div class="col-lg-9">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="row">
                          <div class="col-lg-3">
                            <div class="row">
                              <div class="col-lg-6 p-0 text-center font">
                                药品名称:
                              </div>
                              <div class="col-lg-6 p-0">
                                <input
                                  type="text"
                                  disabled="disabled"
                                  class="form-control font heit"
                                  v-model="searchForm.ypmc1"
                                  @keydown.enter="searchEnterFun"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="row">
                              <div class="col-lg-6 p-0 text-center font">
                                批号:
                              </div>
                              <div class="col-lg-6 p-0">
                                <input
                                  type="text"
                                  class="form-control font"
                                  v-model="searchForm.ph1"
                                  style="height: 1.5rem"
                                  @keydown.enter="searchEnterFun"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="row">
                              <div class="col-lg-6 p-0 text-center font">
                                生产厂家:
                              </div>
                              <div class="col-lg-6 p-0">
                                <input
                                  type="text"
                                 disabled="disabled"
                                  class="form-control font"
                                  v-model="searchForm.cdmc1"
                                  style="height: 1.5rem"
                                  @keydown.enter="searchEnterFun"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="row">
                              <div class="col-lg-6 p-0 text-center font">
                                规格:
                              </div>
                              <div class="col-lg-6 p-0">
                                <input
                                  type="text"
                                  disabled="disabled"
                                  class="form-control font"
                                  v-model="searchForm.gg1"
                                  style="height: 1.5rem"
                                  @keydown.enter="searchEnterFun"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row ml-lg-3">
                      <button
                        class="bg-primary button_zi heit"
                        @click="GetCommodity()"
                      >
                        查询
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <table class="table table-striped table-hover">
                <thead>
                  <tr style="white-space: nowrap">
                    <th>药品名称</th>
                    <th>产地名称</th>
                    <th>仓库</th>
                    <th>规格</th>
                    <th>批号</th>
                    <th>单位</th>
                    <th>包装</th>
                    <th>库存</th>
                    <th>有效期</th>
                    <th>批量价</th>
                    <!-- <th>用户</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in commodityList"
                    :key="index"
                    :class="{ showActive: item.table[index].boss == username }"
                  >
                    <!-- <td class="jz_middle" :class="{showActive:item.itemArray[1]==window.sessionStorage.getItem('boss')}">{{item.itemArray[1]}}</td> -->
                    <td class="jz_middle">
                      {{ item.table[index].ypmc | getString }}
                    </td>

                    <td class="jz_middle">
                      {{ item.table[index].cdmc }}
                    </td>
                    <td class="jz_middle">
                      {{ item.table[index].ck }}
                    </td>
                    <td class="jz_middle">{{ item.table[index].gg }}</td>
                    <td>{{ item.table[index].ph }}</td>
                    <td>{{ item.table[index].dw }}</td>
                    <td>{{ item.table[index].bz }}</td>
                    <td>{{ item.table[index].sl }}</td>
                    <td>{{ item.table[index].yxq }}</td>
                    <td>{{ item.table[index].plj }}</td>
                    <!-- <td>{{item.itemArray[18]}}</td> -->
                  </tr>
                </tbody>
              </table>
              <!-- 分页 -->
              <div>
                <v-pagination
                  :total="total1"
                  :current-page="current1"
                  @pagechange="pagechange1"
                ></v-pagination>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <span aria-hidden="true"></span>关闭
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 这里是弹出调价框 -->
    <div
      class="modal fade"
      id="myModal_jia"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="width: 100%; position: relative; top: 150px; min-width: 500px"
        >
          <div class="modal-header">
            <button
              type="button"
              class="close m-0 p-1"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-header">
                <div class="font">
                  <span class="ml-2"> 以前的批量价为 </span>
                  <span style="color: blue; font-weight: bold" class="ml-2">
                    {{ BeforePrice }}
                  </span>
                  <span class="ml-2"> 修改批量价为 </span>
                  <span style="color: red; font-weight: bold" class="ml-2">
                    {{ ModifyPrice }}
                  </span>
                </div>
              </div>
              <div class="card-body">
                <div>
                  <!-- <p>
                    <select v-model="phoneNumber" class="input_form-control">
                      <option value="">请选择手机号码</option>
                      <option
                        v-for="(item, index) in phones"
                        :key="index"
                        :value="item.tel"
                        v-text="item.tel"
                      ></option>
                    </select>

                    <button
                      class="btn btn-primary ml-5"
                      :disabled="disabled"
                      @click.prevent="getCode()"
                    >
                      {{ btnText }}
                    </button>
                  </p> -->
                  <p class="mt-4">
                  <span>二级密码</span>
                    <input
                      type="text"
                      class="input_form-control"
                      placeholder="请输入二级密码"
                      v-model="securityCode"
                    />   <el-link href="/secondpass">忘记密码?</el-link>
                  </p>
                  <p class="text-center mt-4">
                    <button
                      class="btn btn-primary"
                      @click.prevent="Modification()"
                    >
                      确认修改此价格
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <span aria-hidden="true"></span>关闭
            </button>
            <!-- <button type="button" class="btn btn-primary" data-dismiss="modal"><span aria-hidden="true"></span>确定</button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 是否符合调价条件 -->
    <div
      class="modal fade"
      id="myModal1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="
            width: 500px;
            height: 200px;
            position: relative;
            top: 300px;
            left: 200px;
            margin-bottom: 50px;
          "
        >
          <!-- <div>
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div> -->
          <div class="modal-body" style="font-size: 20px">
            <div
              style="
                width: 300px;
                margin: 0 auto;
                text-align: center;
                margin-bottom: 30px;
                margin-top: 30px;
                color: red;
              "
            >
              你的调价幅度超过10%,确定要继续吗?
            </div>

            <div style="text-align: right">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                @click="isPhones()"
              >
                <span aria-hidden="true"></span>确认
              </button>
              <button
                type="button"
                class="btn btn-info ml-3"
                data-dismiss="modal"
              >
                <span aria-hidden="true"></span>取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";
import { async } from "q";
export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      searchForm: {
        ypmc: "",
        cdmc: "",
        ph: "",
        gg: "",
        ypmc1: "",
        cdmc1: "",
        ph1: "",
        gg1: "",
      }, //搜索内容
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      excelData: [],
      totalPurchMoney: "",
      commodityList: [],
      ModifyPrice: "", //修改价格的值

      BeforePrice: "", //之前的价格

      storeNo: "", //库区
      isRetail: "", //零整

      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数

      total1: 1, // 记录总条数
      display1: 20, // 每页显示条数
      current1: 1, // 当前的页数

      totalCount: 0,
      phoneNumber: "", //选中的手机号码
      username: window.sessionStorage.getItem("username"),
      securityCode: "", //验证码
      success: false,
      disabled: false,
      interval: undefined,
      id: "",
      page2: 1, //这里是刷新页面是页面的当当前位置
      phones: [],
    };
  },
  components: {
    vPagination,
    Loading,
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : "获取验证码";
    },
  },
  filters: {
    //过滤器时间转换

    //截取字符串

    getString: function (str) {
      return str
        .replace(/\([^\)]*\)/g, "")
        .replace(/\（[^\)]*\）/g, "")
        .replace(/\([^\)]*\）/g, "")
        .replace(/\（[^\)]*\)/g, "")
        .replace(/\[.*?\]/g, "");
    },

    //时间转换
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    lin: function (data) {
      if (data == 1) {
        return "零";
      } else {
        return "整";
      }
    },
    rate: function (rate) {
      if (rate == 1) {
        return "不打折";
      } else {
        return "打" + rate * 10 + "折";
      }
    },
  },

  methods: {
    //跳转调价记录页面
    changePage() {
      this.$router.push({ path: "/adjustRecord" });
    },
    //确认修改
    Modification: async function () {
      const that = this;
      // let reg1 = /^[0-9]{6}$/;
      if (!that.securityCode) {
        alert("二级密码不能为空！");
      } else if (that.securityCode.length!=6) {
        alert("您输入的二级密码位数有误！");
      } else {
        await that.$http
          .post("/Dls/ncxhupdatejeNew", {
            yzm: that.securityCode,
            id: that.id,
            dj: that.BeforePrice,
            newdj: that.ModifyPrice,
            phone: that.phoneNumber,
          })
          .then((response) => {
            // console.log(response)
            if (response.data.isOk) {
              that.success = true;
              // console.log(response.data);
              if (response.data.data.message == "") {
                $("#myModal_jia").modal("hide");
                alert("修改价格成功！");
              } else {
                alert(response.data.data.message);
              }
              //  alert("信息已发送，请注意查收")

              //这里重新获取列表
              if (that.searchData.length > 0) {
                that.Search(that.page2);
              } else {
                that.getClerkStoreGoodsQuery(that.page2);
              }
            } else if (!response.data.isOk) {
              alert(response.data.message);

            }
          });
      }
    },

    //获取短信验证码

    getCode() {
      const that = this;
      //  console.log(that.phoneNumber)
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!that.phoneNumber) {
        alert("输入的手机号码不能为空！");
      } else if (!reg.test(that.phoneNumber)) {
        alert("您输入的手机号码有错误！");
      } else {
        that.getsendMessage();
      }
    },
    getsendMessage: async function () {
      //按钮120秒倒计时
      await this.sendMessage(); //120秒倒计时过后才能调用事件
      if (this.success) {
        this.totalCount = 120;
        this.disabled = true;
        this.interval = setInterval(() => {
          this.totalCount--;
          if (this.totalCount === 0) {
            clearInterval(this.interval);
            this.disabled = false;
          }
        }, 1000);
      }
    },
    sendMessage: async function () {
      const that = this;
      await that.$http
        .post("/Dls/addaccount", { phone: that.phoneNumber })
        .then((response) => {
          //  console.log(response)
          if (response.data.isOk) {
            that.success = true;
            // alert("信息已发送，请注意查收")
            that.$message.success("信息已发送，请注意查收!");
          } else if (!response.data.isOk) {
            if (response.data.errorMessage == -3) {
              alert("发送一次短信可以使用1天，1天内不需要发送新短信");
            } else if (response.data.errorMessage == -4) {
              alert("短信发送失败，请联系管理员！");
            }
          }
        });
    },
    //这里是传入价格，并且对价格进行判断
    GetTiaoJia: async function (index) {
      const that = this;
      var purchPrice = 0;
      var highestPrice = 0;
      if (that.searchData.length > 0) {
        that.ModifyPrice = that.searchData[index].value;
        that.BeforePrice = that.searchData[index].price;
        that.id = that.searchData[index].storeID;
        purchPrice = that.searchData[index].purchPrice;
        highestPrice = that.searchData[index].highestPrice;
        that.storeNo = that.searchData[index].storeNo;
        that.isRetail = that.searchData[index].isRetail;
      } else {
        that.ModifyPrice = that.tableData[index].value;
        that.BeforePrice = that.tableData[index].price;
        that.id = that.tableData[index].storeID;
        purchPrice = that.tableData[index].purchPrice;
        highestPrice = that.tableData[index].highestPrice;
        that.storeNo = that.tableData[index].storeNo;
        that.isRetail = that.tableData[index].isRetail;

      }
      // console.log(that.ModifyPrice)
      let reg = /^(?!0+$)(?!0*\.0*$)\d{1,5}(\.\d{1,3})?$/;

      if (!that.ModifyPrice) {
        return alert("您输入的价格不能为空！");
      } else if (!reg.test(that.ModifyPrice)) {
        return alert("输入价格不能带负数，必须为纯数字，小数点最多三位！");
      }

      if (that.storeNo == "aa") {
        if (that.ModifyPrice - that.BeforePrice > 0) {
          alert("零库价格不可以高于当前价格");
        } else if (
          parseFloat((purchPrice * 0.5).toFixed(3)) >
          parseFloat(that.ModifyPrice)
        ) {
          alert("零库每次下调幅度不能超过50%!");
        } else if (
          Math.abs(that.ModifyPrice - that.BeforePrice) >=
          that.BeforePrice * 0.1
        ) {
          $("#myModal1").modal();
        } else {
          //这里先判断有没有手机号

          await that.isPhones();
        }
      } else if (that.storeNo == "02") {
        if (!purchPrice) {
          alert("进价不存在，不可调价");
        } else if (
          parseFloat((purchPrice * 0.8).toFixed(3)) >
            parseFloat(that.ModifyPrice) ||
          parseFloat(that.ModifyPrice) >
            parseFloat((purchPrice * 1.6).toFixed(3))
        ) {
          alert("02库下调价格不能超过进价20%,上调价格不能超过进价60%");
        } else if (
          Math.abs(that.ModifyPrice - that.BeforePrice) >=
          that.BeforePrice * 0.1
        ) {
          $("#myModal1").modal();
        } else {
          //这里先判断有没有手机号

          await that.isPhones();
        }
      } else {
        if (!purchPrice) {
          alert("进价不存在，不可调价");
        } else if (
          parseFloat((purchPrice * 0.8).toFixed(3)) >
          parseFloat(that.ModifyPrice)
        ) {
          alert("整库下调价格不能超过进价20%!");
        } else if (parseFloat(that.ModifyPrice) > parseFloat(highestPrice)) {
          alert("整库价格不能超过最高零售价!");
        } else if (
          Math.abs(that.ModifyPrice - that.BeforePrice) >=
          that.BeforePrice * 0.1
        ) {
          $("#myModal1").modal();
        } else {
          //这里先判断有没有手机号

          await that.isPhones();
        }
      }
    },

    //判读是否有手机号
    isPhones() {
      const that = this;
      that.$http.post("/Dls/GetPhone", {}).then((response) => {
        //  console.log(response)
        if (response.data.isOk) {
          that.phones = response.data.data.rows;
          // console.log(that.phones)
          $("#myModal_jia").modal();
        } else {
          alert(response.data.message);
        }
      });
    },

    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },

    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.ypmc1 = this.searchData[index].drugName;
        this.searchForm.cdmc1 = this.searchData[index].productFactory;
        this.searchForm.gg1 = this.searchData[index].spec;

        this.GetCommodity();
        $("#myModal").modal();
      } else {
        this.searchForm.ypmc1 = this.tableData[index].drugName;
        this.searchForm.cdmc1 = this.tableData[index].productFactory;
        this.searchForm.gg1 = this.tableData[index].spec;

        this.GetCommodity();
        $("#myModal").modal();
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.cdmc = this.searchData[index].productFactory;
      } else {
        this.searchForm.cdmc = this.tableData[index].productFactory;
      }
    },
    // getClerkStoreGoodsQuery: async function (PageIndex) {
    //     const that = this
    //   await that.$http.post('Dls/adjustprice', {
    //       PageIndex,
    //       PageSize:20,
    //       ypmc: that.searchForm.ypmc.trim(),
    //       cdmc: that.searchForm.cdmc.trim(),
    //       gg: that.searchForm.gg.trim(),
    //       ph: that.searchForm.ph.trim(),
    //   }).then(res=>{
    //         //  console.log(res);
    //          if(res.data.isok){
    //               const obj=res.data
    //           that.tableData = obj.data
    //           that.total = obj.record
    //           that.Pcount = obj.pcount
    //           that.Record = obj.record
    //           that.totalPurchMoney=obj.totalPurchMoney
    //          }
    //          else{
    //              alert(res.data.message)
    //          }
    //   })

    // },

    getClerkStoreGoodsQuery: async function (PageIndex) {
      // this.isLoading=true;
      const that = this;
      const { data: res } = await that.$http.post("Dls/getFun", {
        action: "ClerkStoreGoodsQuery",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          SearchType: 2,
          ypmc: that.searchForm.ypmc.trim(),
          cdmc: that.searchForm.cdmc.trim(),
          gg: that.searchForm.gg.trim(),
          ph: that.searchForm.ph.trim(),
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        that.tableData = obj.rows;
        that.total = obj.record;
        that.Pcount = obj.pcount;
        that.Record = obj.record;
        that.totalPurchMoney = obj.totalPurchMoney;
      } else {
        alert(res.message);
      }
    },
    GetCommodity: async function (PageIndex) {
      const that = this;
      that.isLoading = true;
      await that.$http
        .post("Dls/adjustprice2", {
          PageIndex,
          PageSize: 20,
          ypmc: that.searchForm.ypmc1.trim(),
          cdmc: that.searchForm.cdmc1.trim(),
          gg: that.searchForm.gg1.trim(),
          ph: that.searchForm.ph1.trim(),
        })
        .then((res) => {
          //  console.log(res);
          if (res.data.isok) {
            const obj = res.data;
            that.commodityList = obj.data;
            that.total1 = obj.record;
            that.isLoading = false;
            // that.totalPurchMoney=obj.totalPurchMoney
          } else {
            alert(res.data.message);
          }
        });
    },

    //搜索
    //   Search: async function (PageIndex) {
    //   const that = this
    //     that.isLoading=true;

    //  await this.$http.post('Dls/adjustprice', {
    //       PageIndex,
    //       PageSize: 20,
    //       ypmc: that.searchForm.ypmc.trim(),
    //       cdmc: that.searchForm.cdmc.trim(),
    //       gg: that.searchForm.gg.trim(),
    //       ph: that.searchForm.ph.trim(),
    //   }).then(res=>{
    //       // console.log(res)
    //           if(res.data.isok){
    //               const obj = res.data
    //               if(that.Pcount===0){
    //                   that.tableData = obj.data
    //               }
    //               else{
    //                   that.searchData = obj.data
    //                   }
    //                   that.total = obj.record
    //               that.Pcount = obj.pcount
    //               that.Record = obj.record
    //               that.isLoading=false;
    //               if(obj.pcount==0){
    //                       alert('没有符合条件的信息')
    //                       that.getClerkStoreGoodsQuery();
    //               }

    //           }
    //           else{
    //               that.isLoading=false;
    //               alert(res.data.message);
    //           }
    //   })

    //   },

    Search: async function (PageIndex) {
      const that = this;
      that.isLoading = true;
      const { data: res } = await that.$http.post("Dls/getFun", {
        action: "ClerkStoreGoodsQuery",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          SearchType: 2,
          DrugName: that.searchForm.ypmc.trim(),
          BatchNum: that.searchForm.ph.trim(),
          ProductFactory: that.searchForm.cdmc.trim(),
          Spec: that.searchForm.gg.trim(),
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        if (that.Pcount === 0) {
          that.tableData = obj.rows;
        } else {
          that.searchData = obj.rows;
        }
        that.total = obj.record;
        that.Pcount = obj.pcount;
        that.Record = obj.record;
        that.isLoading = false;
        if (obj.pcount == 0) {
          alert("没有符合条件的信息");
          that.getClerkStoreGoodsQuery();
        }
      } else {
        that.isLoading = false;
        alert(res.message);
      }
    },

    pagechange: function (currentPage) {
      this.page2 = currentPage;
      if (this.searchData.length > 0) {
        this.Search(currentPage);
      } else {
        this.getClerkStoreGoodsQuery(currentPage);
      }
    },
    pagechange1: function (currentPage) {
      this.GetCommodity(currentPage);
    },
    //搜索功能
    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.getClerkStoreGoodsQuery();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.heit {
  height: 1.5rem;
}
.span_close:hover {
  color: #3190e8;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.jz_middle {
  vertical-align: middle;
}
.input_form-control {
  /* // display: block;  */
  width: 50%;
  height: 38px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}
.showActive {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/PriceAdjustment.vue